import React, { useEffect, useState} from 'react';
import Menu from "../Header/Menu";
import {
    Avatar,
    Card, CardActionArea, CardHeader,
    CssBaseline,
    makeStyles,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import LowPriorityIcon from '@material-ui/icons/LowPriority';
import { loadAreasList } from "../httpUtils";
import Typography from "@material-ui/core/Typography";
import EditAreaDialog from "./EditAreaDialog";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(2),
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    accordion: {
        marginBottom: theme.spacing(2),
    },
    card:{
        width: '100%'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'row',
    },
    avatar: {
        backgroundColor: theme.palette.primary.main,
        width: 45,
    },
    alert: {
        marginTop: theme.spacing(2),
    },
    licencePlateAllowToAllAvatar: {
        backgroundColor: '#4CAF50',
        width: 45,
    },
    licencePlatePartialDisallowAvatar: {
        backgroundColor: '#FFC107',
        width: 45,
    },
    licencePlateFullDisallowAvatar: {
        backgroundColor: '#F44336',
        width: 45,
    },
    areaAccessAccordion: {
        marginTop: theme.spacing(1),
        '&$expanded': {
            margin: 0,
            transform: "rotate(0deg)",
        },
    }
}));

export default function AreasSettings(props) {
    const classes = useStyles();

    const [areaList, setAreaList] = useState([]);
    const [currentArea, setCurrentArea] = useState(0);

    const loadCameras = () => {
        loadAreasList().then((r)=>{
            setAreaList(r)
        })
    }

    useEffect(()=>{
        loadCameras()
    }, [])

    function getAvatarClassname(guest){
        return guest ? classes.licencePlateAllowToAllAvatar : classes.licencePlatePartialDisallowAvatar
    }

    function getAvatarIcon(capacity){
        return capacity ? <LowPriorityIcon/> : <AllInclusiveIcon/>
    }


    return (
        <React.Fragment>
            <Menu title='Участки'/>
            <CssBaseline />
            <div className={classes.root}>
                <Grid container spacing={1}>
                    { areaList.length > 0 && areaList.map((data, i) => (
                        <Grid container item xs={12} sm={6} md={4} lg={4} xl={2}>
                            <Card className={classes.card}>
                                <CardActionArea style={{ textDecoration: 'none' }} onClick={()=>{
                                    setCurrentArea(data.id);
                                }}>
                                    <CardHeader
                                        avatar={
                                            <Avatar variant="rounded" aria-label="recipe" className={getAvatarClassname(data.guest)}>
                                                { getAvatarIcon(data.capacity) }
                                            </Avatar>
                                        }
                                        subheader={
                                            <React.Fragment>
                                                <Typography variant="h5" component="h2">{data.name}</Typography>
                                            </React.Fragment>
                                        }
                                    />
                                </CardActionArea>
                            </Card>

                        </Grid>
                    ))
                    }
                </Grid>
            </div>
            <EditAreaDialog id={currentArea} open={currentArea > 0} needClose={()=>{setCurrentArea(0)}} needReload={()=>{loadCameras()}}/>
        </React.Fragment>
    )
}
